<template>
  <div>
    <div id="header-wrapper">
			<div class="header">
				<h1>Buttons</h1>
			</div>
		</div>
		<!--Content-->
		<div id="content">
      <h2>Types</h2>

      <h3>Primary</h3>
      <div class="right">
        <mt-button type="primary">Primary</mt-button>
      </div>

      <h3>Secondary</h3>
      <div class="right">
        <mt-button type="secondary">Secondary</mt-button>
        <mt-button type="secondary-gray">Secondary</mt-button>
      </div>

      <h3>Default</h3>
      <div class="right">
        <mt-button size="small" type="default">Default</mt-button>
      </div>

      <h3>Subtle</h3>
      <div class="right">
        <mt-button type="subtle" size="small">Subtle</mt-button>
      </div>

      <h3>Icon in button</h3>
      <div class="right">
        <mt-button size="small" icon="settings">Icon in button</mt-button>
        <mt-button size="small" icon="settings"></mt-button>
      </div>

      <h3>Disabled</h3>
      <div class="right">
        <mt-button size="small" disabled>Disabled</mt-button>
      </div>

      <h2>Style</h2>

      <h3>Colors</h3>
      <div class="left height250 mt--bg--neutrals-light-gray-01">
        <div class="caption">Primary</div>
        <mt-button type="primary">Primary</mt-button>
      </div>
      <div class="right">
        <p>Background: #055AFE</p>
        <p>Text: #FFFFFF</p>
      </div>
      <div class="mt--clearfix"></div>

      <div class="left height250 mt--bg--neutrals-light-gray-01">
        <div class="caption">Secondary</div>
        <mt-button type="secondary">Secondary</mt-button>
        <mt-button type="secondary-gray">Secondary</mt-button>
      </div>
      <div class="right">
        <p>Border: #055AFE</p>
        <p>Text: #055AFE</p>
        <p>border: #718091</p>
        <p>Text: #718091</p>
      </div>
      <div class="mt--clearfix"></div>

      <div class="left height250 mt--bg--neutrals-light-gray-01">
        <div class="caption">Default</div>
        <mt-button type="default" size="small">Default</mt-button>
      </div>
      <div class="right">
        <p>Background: #EDEFF3</p>
        <p>Border: #B2C0D0</p>
        <p>Text: #485464</p>
      </div>
      <div class="mt--clearfix"></div>

      <div class="left height250 mt--bg--neutrals-light-gray-01">
        <div class="caption">Subtle</div>
        <mt-button type="subtle" size="small">Subtle</mt-button>
      </div>
      <div class="right">
        <p>Text: #485464</p>
      </div>
      <div class="mt--clearfix"></div>

      <div class="left height250 mt--bg--neutrals-light-gray-01">
        <div class="caption">Icon in button</div>
        <div>
          <mt-button icon="settings" size="small">Icon in button</mt-button>
          <mt-button size="small" icon="settings"></mt-button>
        </div>
      </div>
      <div class="right">
        <p>Text: #485464</p>
      </div>
      <div class="mt--clearfix"></div>

      <div class="left height250 mt--bg--neutrals-light-gray-01">
        <div class="caption">Disabled</div>
        <div>
          <mt-button size="small" disabled>Disabled</mt-button>
        </div>
      </div>
      <div class="right">
        <p>Background: #EDEFF3</p>
        <p>Text: #B2C0D0</p>
      </div>
      <div class="mt--clearfix"></div>

      <h3>Sizing</h3>
      <div class="left">
        <img :src="sizeDefault" alt="">
      </div>
      <div class="right">
        <p>Corner radius: 4px</p>
        <p>Height: 48px</p>
        <p>Horizontal padding: 16px</p>
        <p>Minimum width: 150px</p>
        <p>Font size: 16px</p>
        <p>Line height: 24px </p>
        <p>border: 2px</p>
      </div>
      <div class="mt--clearfix"></div>

      <div class="left">
        <img :src="sizingSmall" alt="">
      </div>
      <div class="right">
        <p>Corner radius: 2px</p>
        <p>Height: 36px</p>
        <p>Horizontal padding: 12px</p>
        <p>Font size: 14px </p>
        <p>Line height: 22px </p>
        <p>border: 1px</p>
      </div>
      <div class="mt--clearfix"></div>

      <div class="left">
        <img :src="sizingSmallinButton" alt="">
      </div>
      <div class="right">
        <p>Corner radius: 2px</p>
        <p>Height: 36px</p>
        <p>Font size: 14px </p>
        <p>Line height: 22px </p>
        <p>border: 1px</p>
      </div>
      <div class="mt--clearfix"></div>

      <h2>States</h2>
      <div class="left">
        <img :src="statesPrimary" alt="">
      </div>
      <div class="right">
        <p>Default background: #097DB7   text: #FFFFFF</p>
        <p>Hover background: #0D72A9   text: #FFFFFF</p>
        <p>Active background: #106391   text: #FFFFFF</p>
        <p>Disabled background: #EDEFF3  Text: #485464  opacity 30%</p>
      </div>
      <div class="mt--clearfix"></div>

      <div class="left">
        <img :src="statesSecondary" alt="">
      </div>
      <div class="right">
        <p>Default border: #097DB7   text: #097DB7</p>
        <p>Hover background: #0D72A9   text: #FFFFFF</p>
        <p>Active background: #106391   text: #FFFFFF</p>
        <p>Disabled background: #EDEFF3   Text: #485464  opacity 30%</p>
        <br />
        <p>Default border: #718091   text: #718091</p>
        <p>Hover border: #0D72A9   text: #0D72A9</p>
        <p>Active background: #106391   text: #FFFFFF</p>
        <p>Disabled background: #EDEFF3   Text: #485464  opacity 30%</p>
      </div>
      <div class="mt--clearfix"></div>

      <div class="left">
        <img :src="statesDefault" alt="">
      </div>
      <div class="right">
        <p>Default background: #EDEFF3   border: #B2C0D0   text: #485464</p>
        <p>Hover background: #0D72A9   text: #FFFFFF</p>
        <p>Active background: #106391   text: #FFFFFF</p>
        <p>Disabled background: #EDEFF3    Text: #485464  opacity 30%</p>
      </div>
      <div class="mt--clearfix"></div>

      <div class="left">
        <img :src="statesSubtle" alt="">
      </div>
      <div class="right">
        <p>Default text: #485464</p>
        <p>Hover text: #0D72A9</p>
        <p>Active text: #106391</p>
        <p>Disabled Text: #485464  opacity 30%</p>
      </div>
      <div class="mt--clearfix"></div>

      <div class="left">
        <img :src="statesIconInButton" alt="">
      </div>
      <div class="right">
        <p>Default background: #EDEFF3   border: #B2C0D0   text: #485464   icon: #485464  opacity 80%</p>
        <p>Hover background: #0D72A9   text: #FFFFFF   icon: #FFFFFF   </p>
        <p>Active background: #106391   text: #FFFFFF   icon: #FFFFFF</p>
        <p>Disabled background: #EDEFF3   Text: #485464  opacity 30%   icon: #485464  opacity 30%</p>
      </div>
      <div class="mt--clearfix"></div>

		</div>
  </div>
</template>
<script>
export default {
  name: 'buttons-page',
  data () {
    return {
      sizeDefault: require('@/assets/buttons-sizing-default.svg'),
      sizingSmallinButton: require('@/assets/buttons-sizing-small-in-button.svg'),
      sizingSmall: require('@/assets/buttons-sizing-small.svg'),
      statesIconInButton: require('@/assets/states-icon-in-button.svg'),
      statesPrimary: require('@/assets/states-primary.svg'),
      statesSecondary: require('@/assets/states-secondary.svg'),
      statesDefault: require('@/assets/states-default.svg'),
      statesSubtle: require('@/assets/states-subtle.svg'),
    }
  }
}
</script>
<style lang="scss" scoped>

p {
  font-size: 14px;
  line-height: 1.57;
  margin: 0;
}
h3 { font-size: 16px; }
.right {
  width: 46%;
  padding: 2%;
  float: right;
  height: 94px;
  .button-wrap{
    padding-right: 20px;
  }
}
.left{
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  width: 50%;
  float: left;
  position: relative;
  margin-bottom: 2em;
  &.height250 { height: 250px; }
  .caption {
    position: absolute;
    left: 15px;
    top: 15px;
  }
  .button-wrap + .button-wrap {
    margin-top: 1.5em;
  }
}
</style>



// WEBPACK FOOTER //
// Buttons.vue?3a4ac4bf